module.exports = __webpack_public_path__ + "static/media/stars.176ef2df.svg";